import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'

function getBase64FromImage(imgUrl) {
    return new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            resolve(canvas.toDataURL('image/png'))
        }
        img.src = imgUrl
    })
}

function formatearFecha(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    }).format(new Date(fecha))
}
function formatearFechaHora(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(fecha))
}

function tituloSeccion(doc, texto, y) {
    doc.setFontSize(10)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0)
    doc.text(texto.toUpperCase(), 14, y)

    doc.setDrawColor(0)
    doc.setLineWidth(0.6)
    doc.line(14, y + 2, 200, y + 2)

    return y + 8
}

function textJustify(doc, text, x, y, maxWidth, lineHeight, bottomMargin = 20) {
    const lines = doc.splitTextToSize(text, maxWidth)

    lines.forEach((line, idx) => {
        if (y + lineHeight > doc.internal.pageSize.getHeight() - bottomMargin) {
            doc.addPage()
            y = 20
        }

        const words = line.trim().split(/\s+/)
        if (words.length <= 1 || idx === lines.length - 1) {
            doc.text(line, x, y)
        } else {
            const totalTextWidth = words.reduce((acc, w) => acc + doc.getTextWidth(w), 0)
            const spaceWidth = (maxWidth - totalTextWidth) / (words.length - 1)

            let xOffset = x
            words.forEach((word, i) => {
                doc.text(word, xOffset, y)
                if (i < words.length - 1) {
                    xOffset += doc.getTextWidth(word) + spaceWidth
                }
            })
        }
        y += 5
    })
    return y // Devuelve la nueva posición vertical
}

function formatMayusculas(palabras) {
    return palabras.toUpperCase()
}

async function generarAvisoPrivacidad(paciente, estudio) {
    const doc = new jsPDF('p', 'mm', 'letter')


    const logo1 = await getBase64FromImage(logoIzquierdo)
    const logo2 = await getBase64FromImage(logoDerecho)

    const pageWidth = doc.internal.pageSize.getWidth()
    const margin = 20
    const anchoTexto = pageWidth - 2 * margin
    const lineHeight = 4

    // Logo izquierdo
    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)

    // Logo derecho
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(12)
    doc.setFont('helvetica', 'bold')
    doc.text('AVISO DE PRIVACIDAD INTEGRAL', pageWidth / 2, 25, { align: 'center' })

    let y = 45
    let texto1 = 'Los Servicios de Salud del Estado de Durango con domicilio Avenida Cuauhtemoc 225, Zona Centro, 34000, Durango, Dgo., es el responsable del tratamiento de los datos personales que nos proporcione, los cuales serán protegidos conforme a lo dispuesto por la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados, la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados del Estado de Durango, y demás normatividad que resulte aplicable.'

    let titulo1 = 'FINALIDADES DEL TRATAMIENTO DE LOS DATOS PERSONALES'
    let texto2 = 'Los datos personales que se recaban serán utilizados para las siguientes finalidades:'
    let texto3 = '• Dar contestación a las solicitudes de Acceso a la Información a través de la Plataforma Nacional de Transparencia, con la colaboración de la información proporcionada por las diversas áreas de los Servicios de Salud del Estado de Durango.'
    let texto4 = '• Dar trámite a las denuncias en materia de Transparencia.'
    let texto5 = '• Dar respuesta a los recursos de revisión que se notifiquen a la Unidad de Transparencia.'
    let texto6 = '• Solicitud de derechos ARCO.'
    let texto7 = '• Auxiliar a los particulares en la elaboración de solicitudes de acceso a la información y en su caso orientarlos sobre los sujetos obligados competentes.'

    let titulo2 = 'DATOS PERSONALES QUE SE RECABAN'
    let texto8 = 'Para las finalidades antes señaladas se solicitarán los siguientes datos personales: datos identificativos, datos electrónicos, datos especialmente protegidos (sensibles) y datos personales de naturaleza pública. El titular de los datos personales no está obligado a proporcionar datos sensibles que hagan referencia a la esfera íntima de su persona, tales como origen racial y étnico, estado de salud, información genética, creencias religiosas, filosóficas, morales y/o preferencias políticas.'

    let titulo3 = 'FUNDAMENTO LEGAL PARA EL TRATAMIENTO DE DATOS PERSONALES'
    let texto9 = 'Los Servicios de Salud del Estado de Durango a través de la Unidad de Transparencia, trata los datos personales antes señalados con fundamento en el artículo 20 de la Ley Orgánica de la Administración Pública del Estado de Durango y demás disposiciones aplicables en la materia.'

    let titulo4 = 'TRANSFERENCIA DE DATOS PERSONALES'
    let texto10 = 'Le informamos que sus datos personales pueden ser compartidos con el Instituto Duranguense de Acceso a la Información Pública y de Protección de Datos Personales, así como con la Secretaría de Contraloría del Estado de Durango, de igual manera con los solicitantes de Información que pueda ser generada por este Sujeto Obligado a través de la Plataforma Nacional de Transparencia, para dar cumplimiento a la normatividad aplicable en materia de transparencia y acceso a la información. Se informa que se realizarán transferencias adicionales, únicamente que sean necesarias para atender requerimientos de información de autoridad competente, que estén debidamente fundados y motivados.'

    let titulo5 = 'EJERCICIO DE LOS DERECHOS ARCO'
    let titulo6 = '(ACCESO, RECTIFICACIÓN, CANCELACIÓN U OPOSICIÓN DE DATOS PERSONALES)'
    let texto11 = 'El titular de los datos personales o en su caso el representante legal, podrá ejercer su derecho de: conocer qué datos personales nos ha proporcionado, para qué los utilizamos y las condiciones del uso que les damos (Acceso); de solicitar la corrección de su información personal cuando esté incompleta, sea inexacta, inadecuada o excesiva (Rectificación); de que se elimine de nuestros registros o bases de datos cuando considere que su tratamiento contraviene lo dispuesto por la Ley de Protección de Datos Personales en Posesión de los Sujetos Obligados del Estado de Durango o porque dejó de ser necesaria para el cumplimiento de la finalidado finalidades de dicha base (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición).'
    let texto12 = 'Es importante señalar que para el ejercicio de los derechos ARCO, el titular podrá hacerlo mediante la Plataforma Nacional de Transparencia www.plataformadetransparencia.org.mx Los requisitos que debe cumplir para presentar una solicitud de Derechos ARCO, son los siguientes: 1. El nombre del titular y su domicilio o cualquier otro medio para recibir notificaciones; 2. Los documentos que acrediten la identidad del titular y, en su caso, la personalidad e identidad de su representante; 3. De ser posible, el área responsable que trata los datos personales, y ante el cual se presenta la solicitud; 4. La descripción clara y precisa de los datos personales respecto de los que se busca ejercer alguno de los derechos ARCO, salvo que se trate del derecho de acceso; 5. La descripción del derecho ARCO que se pretende ejercer o, bien, lo que solicita el titular, y 6. Cualquier otro elemento o documento que facilite la localización de los datos personales, de ser necesario.'
    let texto13 = 'En caso de solicitar la rectificación, adicionalmente deberá indicar las modificaciones a realizarse y aportar la documentación oficial necesaria que sustente su petición. En el derecho de cancelación debe expresar las causas que motivan la eliminación. Y en el derecho de oposición debe señalar los motivos que justifican se finalice el tratamiento de los datos personales y el daño o perjuicio que le causaría o, bien, si la oposición es parcial, debe indicar las finalidades específicas con las que no está de acuerdo, siempre que no sea un requisito obligatorio. La Unidad de Transparencia responderá en el domicilio o medio que el titular de los datos personales designe en su solicitud, en un plazo de 20 días hábiles, que puede ser ampliado por 10 días hábiles más, previa notificación. La respuesta indicará si la solicitud de acceso, rectificación, cancelación u oposición es procedente y, en su caso, hará efectivo dentro de los 15 días hábiles siguientes a la fecha en que comunique la respuesta.'

    doc.setFont('helvetica', 'normal')

    y = textJustify(doc, texto1, margin, y, anchoTexto, lineHeight)

    doc.setFont('helvetica', 'bold')
    doc.text(titulo1, pageWidth / 2, y += 5, { align: 'center' })

    doc.setFont('helvetica', 'normal')
    y = textJustify(doc, texto2, margin, y += 7, anchoTexto, lineHeight)
    y = textJustify(doc, texto3, margin + 3, y += 1, anchoTexto - 3, lineHeight)
    y = textJustify(doc, texto4, margin + 3, y += 1, anchoTexto - 3, lineHeight)
    y = textJustify(doc, texto5, margin + 3, y += 1, anchoTexto - 3, lineHeight)
    y = textJustify(doc, texto6, margin + 3, y += 1, anchoTexto - 3, lineHeight)
    y = textJustify(doc, texto7, margin + 3, y += 1, anchoTexto - 3, lineHeight)

    doc.setFont('helvetica', 'bold')
    doc.text(titulo2, pageWidth / 2, y += 5, { align: 'center' })

    doc.setFont('helvetica', 'normal')
    y = textJustify(doc, texto8, margin, y += 7, anchoTexto, lineHeight)

    doc.setFont('helvetica', 'bold')
    doc.text(titulo3, pageWidth / 2, y += 5, { align: 'center' })

    doc.setFont('helvetica', 'normal')
    y = textJustify(doc, texto9, margin, y += 7, anchoTexto, lineHeight)

    doc.setFont('helvetica', 'bold')
    doc.text(titulo4, pageWidth / 2, y += 5, { align: 'center' })

    doc.setFont('helvetica', 'normal')
    y = textJustify(doc, texto10, margin, y += 7, anchoTexto, lineHeight)

    doc.setFont('helvetica', 'bold')
    doc.text(titulo5, pageWidth / 2, y += 5, { align: 'center' })
    doc.text(titulo6, pageWidth / 2, y += 5, { align: 'center' })

    doc.setFont('helvetica', 'normal')
    y = textJustify(doc, texto11, margin, y += 7, anchoTexto, lineHeight)
    y = textJustify(doc, texto12, margin, y += 7, anchoTexto, lineHeight)
    y = textJustify(doc, texto13, margin, y += 7, anchoTexto, lineHeight)

    const lineaY = y
    doc.setFontSize(10)
    doc.setFont('helvetica', 'bold')

    doc.line(pageWidth / 2 - 30, lineaY + 25    , pageWidth / 2 + 30, lineaY + 25)
    doc.text(formatMayusculas('JAVIER PEREZ REYES'), pageWidth / 2, lineaY + 30, { align: 'center' })
    doc.text('NOMBRE Y FIRMA DE CONOCIMIENTO', pageWidth / 2, lineaY + 35, { align: 'center' })

    doc.save('AvisoPrivacidad.pdf')
}
export { generarAvisoPrivacidad }